<div class="cio">
  <div class="buttons" [ngClass]="routeAnimationsElements">
    <button (click)="onCancel()" mat-icon-button color="primary" style="background-color: #004a8f; padding: 0px;">
      <mat-icon style="color: white;">arrow_back</mat-icon>
    </button>
  </div>
  <mat-tab-group>
    <mat-tab label="Viveros">
      <div class="buttons">
        <button mat-raised-button (click)="onAdd()" color="primary">
          Registrar vivero
        </button>
      </div>
      <rpe-base-table [baseTable]="baseTableOptions" [showActions]="true" [actionMenu]="false"></rpe-base-table>
    </mat-tab>
  </mat-tab-group>
</div>